import { NavLink, Outlet } from 'react-router-dom';
import { BookOpen, ListOrdered, Scale, TrendingUp, Building2 } from 'lucide-react';
import { SectionHeader } from '@/components/ui/Card';
import { cn } from '@/lib/utils';

const NAV = [
  { to: '/accounting/chart',         label: 'Chart of Accounts', icon: BookOpen },
  { to: '/accounting/journal',       label: 'Journal',           icon: ListOrdered },
  { to: '/accounting/trial-balance', label: 'Trial Balance',     icon: Scale },
  { to: '/accounting/pnl',           label: 'Profit & Loss',     icon: TrendingUp },
  { to: '/accounting/balance-sheet', label: 'Balance Sheet',     icon: Building2 },
];

export function AccountingLayout() {
  return (
    <div className="space-y-8">
      <SectionHeader
        kicker="Accounting · General Ledger"
        title="Double-entry books."
        description="Chart of accounts, journal, reports, close. The canonical record of every financial movement."
      />

      <div className="border-b border-border overflow-x-auto -mx-8 px-8">
        <nav className="flex gap-1 -mb-px">
          {NAV.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'inline-flex items-center gap-2.5 px-5 h-11 text-xs uppercase tracking-[0.15em] transition-colors border-b-2 whitespace-nowrap',
                    isActive
                      ? 'border-brass-400 text-text'
                      : 'border-transparent text-text-muted hover:text-text',
                  )
                }
              >
                <Icon size={13} />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </div>

      <div>
        <Outlet />
      </div>
    </div>
  );
}
